export default "__VITE_ASSET__Bqu04Nv8__"